import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";

const { Option } = Select;

// When `options` is supplied the caller owns the list (e.g. options derived from
// the rows actually shown in a table); the component then skips its own fetch.
const SegmentSelect = ({ brandId, categoryId, value, onChange, multiple = false, disabled = false, shouldFetch = false, showAll = false, options, optionsLoading = false }) => {

  const isControlledList = Array.isArray(options);

  const { request } = useRequest();
  const [segmentList, setSegmentList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSegments = async () => {

    let url = apiPath.commonSegment;
    const params = [];
    if (brandId) params.push(`brand_id=${brandId}`);
    if (categoryId) params.push(`category_id=${categoryId}`);
    if (params.length) url += `?${params.join('&')}`;

    setLoading(true);
    request({
      url,
      method: "GET",
      onSuccess: (res) => {
        const segments = res?.data?.data || [];
        setSegmentList(segments);
        setLoading(false);
        if ((brandId || categoryId) && value && !segments.some(s => s._id === value)) {
          onChange?.(undefined);
        }
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(
          err?.response?.data?.message || "Failed to load segments",
          Severty.ERROR
        );
      },
    });
  };

  useEffect(() => {
    if (isControlledList) return;
    fetchSegments();
  }, [shouldFetch, brandId, categoryId, isControlledList]);

  const list = isControlledList ? options : segmentList;
  const isLoading = isControlledList ? optionsLoading : loading;

  return (
    <Spin spinning={isLoading} tip="Loading segments..." size="small">
      <Select
        mode={multiple ? "multiple" : undefined}
        showSearch
        allowClear
        placeholder="Select segment"
        optionFilterProp="children"
        value={value}
        onChange={onChange}
        disabled={disabled}
        loading={isLoading}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        className="w-full"
        style={{ height: 40 }}
      >
        {showAll && multiple && (
          <Option key="all" value="all">
            <span className="text-blue-500 font-medium">Select All</span>
          </Option>
        )}
        {list?.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.en_name}
          </Option>
        ))}
      </Select>
    </Spin>
  );
};

export default SegmentSelect;
